// 定义环境类型
type Environment = 'development' | 'test' | 'production' | 'local';

// 定义功能标志接口
interface FeatureFlags {
    streaming: boolean;
    searchPreview: boolean;
}

// 定义环境配置接口
interface EnvConfig {
    apiBaseUrl: string;
    analytics: boolean;
    featureFlags: FeatureFlags;
}

// 定义全局配置接口
interface GlobalConfig extends EnvConfig {
    currentEnv: Environment;
    isDevelopment: boolean;
    isTest: boolean;
    isProduction: boolean;
}

// 根据环境变量自动确定当前环境
const getEnv = (): Environment => {
    const host = window.location.href;


    if (host.includes('localhost') || host.includes('127.0.0.1') || host.includes('https://beefin.tech/dev/')) {
        return 'development';
    }
    if (host.includes('https://beefin.tech/local/')) {
        return 'local';
    }
    if (host.includes('http://beefin.tech/uat/')) {
        return 'test';
    }
    if (host.includes('https://beefin.tech/')) {
        return 'production';
    }
    return 'development';
};

const currentEnv = getEnv();

// 环境配置映射
const envConfig: Record<Environment, EnvConfig> = {
    development: {
        apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'https://test.chat.lifebee.tech/api',
        analytics: false,
        featureFlags: {
            streaming: import.meta.env.VITE_FEATURE_STREAMING === 'true' || true,
            searchPreview: true,
        }
    },
    local: {
        apiBaseUrl:  'http://127.0.0.1:8090/api',
        analytics: false,
        featureFlags: {
            streaming: import.meta.env.VITE_FEATURE_STREAMING === 'true' || true,
            searchPreview: true,
        }
    },
    test: {
        apiBaseUrl: 'https://test.chat.lifebee.tech/api',
        analytics: false,
        featureFlags: {
            streaming: false,
            searchPreview: true,
        }
    },
    production: {
        apiBaseUrl: 'https://api.chat.lifebee.tech/api',
        analytics: true,
        featureFlags: {
            streaming: false,
            searchPreview: false,
        }
    }
};

// 当前环境配置
export const config: GlobalConfig = {
    ...envConfig[currentEnv],
    currentEnv,
    isDevelopment: currentEnv === 'development',
    isTest: currentEnv === 'test',
    isProduction: currentEnv === 'production',
};

console.log(`当前运行环境: ${currentEnv}`, config);
